import { render } from "./SalesGuide.vue?vue&type=template&id=24362c9a&scoped=true&ts=true"
import script from "./SalesGuide.vue?vue&type=script&lang=ts"
export * from "./SalesGuide.vue?vue&type=script&lang=ts"

import "./SalesGuide.vue?vue&type=style&index=0&id=24362c9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24362c9a"]])

export default __exports__